import api from '../../api.js';

function defaultState() {
    return {
        // org database fields
        id: '',
        name: '',
        region_code: '',
        alt_region_code: '',
        settings: {},
        subdomain: '',
        limits: {},
        is_super_admin: false,
        admin_partner_id: null,
        app_branding: false,
        // fronend-added fields
        users: {},
        infoLastLoaded: 0,
    };
}

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        infoLastLoaded(state) {
            return state.infoLastLoaded;
        },
        exists(state) {
            return !!state.id;
        },
        org(state) {
            return state;
        },
        user: state => userId => {
            return state.users[userId];
        },
        users(state) {
            return state.users;
        },
        url(state, getters, rootState, rootGetters) {
            if (state.app_branding && state.app_branding.domain) {
                // Netlify doesn't support wildcard subdomains for domain aliases (non-primary domain)
                // so we can't use the org subdomain if the partner uses a custom domain
                return `${rootState.base.protocol}//${state.app_branding.domain}`;
            }
            if (state.subdomain && rootState.base.subdomain != "none") {
                return `${rootState.base.protocol}//${state.subdomain}.${rootState.base.domain}`;
            }
            return rootGetters['base/url'];
        },
        isAdmin(state) {
            return state.is_super_admin || !!state.admin_partner_id;
        },
    },
    mutations: {
        setInfoLastLoaded(state, time) {
            state.infoLastLoaded = time;
        },
        update(state, org) {
            if (org.id && org.id !== state.id) {
                org.users = {};
            }
            for (let key in org) {
                state[key] = org[key];
            }
        },
        users(state, users) {
            state.users = users;
        },
        clear(state) {
            let defaults = defaultState();
            for (let key in defaults) {
                state[key] = defaults[key];
            }
        }
    },
    actions: {
        async save({ commit }, data) {
            await api.put('org', data);
            commit('update', data);
        },
        async loadInfo({ getters, commit }, infoProps = ['users', 'boxes']) {
            // 1s throttle, to prevent double firing on initial page load sometimes
            if (Date.now() - getters.infoLastLoaded < 1000) {
                return;
            }
            commit('setInfoLastLoaded', Date.now());

            let promises = [
                infoProps.includes('org') ? api.get('org') : null,
                infoProps.includes('users') || infoProps.includes('boxes') ? api.get('org/info') : null,
            ];
            let [org, info] = await Promise.all(promises);

            if (org) commit('update', org);
            if (info) {
                if (info.users) {
                    let orgUsers = {};
                    for (let user of info.users) {
                        user.name = user.fname && user.lname ? `${user.fname} ${user.lname}` : 'New User';
                        user.name_reversed = user.fname && user.lname ? `${user.lname}, ${user.fname}` : 'New User';
                        orgUsers[user.id] = user;
                    }
                    commit('users', orgUsers);
                }
                if (info.boxes) {
                    commit('boxes/setBoxes', info.boxes, { root: true });
                }
            }
        },
    }
}